const { Fragment, useState, useRef, useEffect } = wp.element;
const { PanelBody, PanelRow, Button, __experimentalNumberControl: NumberControl, TextControl, FormToggle, SelectControl, TextareaControl, ButtonGroup, __experimentalUnitControl: UnitControl } = wp.components;
const { __ } = wp.i18n;

const Streaming = ({ attributes, setAttributes }) => {
  const { streaming, streamingType } = attributes;
  return (
    <PanelBody title={__("Streaming", "h5vp")} initialOpen={false}>
      <PanelRow>
        <label className="label" htmlFor="streaming">
          {__("Enable Streaming", "h5vp")}
        </label>
        <FormToggle id="streaming" checked={streaming} onChange={() => setAttributes({ streaming: !streaming })} />
      </PanelRow>
      {streaming && (
        <Fragment>
          <PanelRow className="inline">
            <label htmlFor="" className="label">
              {__("Streaming Type")}
            </label>
            <SelectControl
              value={streamingType}
              options={[
                { label: "Hls.js", value: "hls" },
                { label: "Dash.js", value: "dash" },
                // { label: "Shaka Player", value: "shaka" },
              ]}
              onChange={(streamingType) => {
                setAttributes({ streamingType });
              }}
            />
          </PanelRow>
        </Fragment>
      )}
    </PanelBody>
  );
};

export default Streaming;
